import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import { IServicesCategoryNomenclature, IServicesCategoryNomenclatureListItem } from '@/entity/servicesCategoryNomenclature/services.category.nomenclature.types';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import { ServiceCategoryNomenclatureCreateRequestType } from '@/form/serviceCategory/serviceCategoryCreate.types';
import { ServiceCategoryNomenclatureUpdateRequestType } from '@/form/serviceCategory/serviceCategoryUpdate.types';
import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper'

@Module({
    namespaced: true,
    name: 'servicesCategoryNomenclature',
    store,
    dynamic: true
})

class ServicesCategoryNomenclatureModule extends VuexModule implements IStoreReady  {
    items: IServicesCategoryNomenclature | null = null
    item: IServicesCategoryNomenclatureListItem | null = null
    itemsLoaded = false
    itemLoaded = false
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: IServicesCategoryNomenclature;  itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const items = await store.$repository.servicesCategoryNomenclature.fetchAll(prepareFormData(data));
        if(items){
            itemsLoaded = true;
        }
        return { items, itemsLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ item: IServicesCategoryNomenclatureListItem  ; itemLoaded: boolean }> {
        let itemLoaded = false;
        const item = await store.$repository.servicesCategoryNomenclature.fetchData(data);
        if (item) {
            itemLoaded = true;
        }
        return { item, itemLoaded};
    }

    @Action({rawError: true})
    async create(data: ServiceCategoryNomenclatureCreateRequestType): Promise<ResponseDataType> {
        return await store.$repository.servicesCategoryNomenclature.create(data);
    }
    @Action({rawError: true})
    async update(data: ServiceCategoryNomenclatureUpdateRequestType): Promise<ResponseDataType> {
        return await store.$repository.servicesCategoryNomenclature.update(data);
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return await store.$repository.servicesCategoryNomenclature.delete(data);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
    
}

export const ServicesCategoryNomenclatureStore = getModule(ServicesCategoryNomenclatureModule);